import React from 'react';
import css from './Footer.module.css';

export default function Footer() {
  return (<div className={css.footer}>
        <span className={css.footerheading}>Copyright 2001-2022 © PhoneArena Ltd. All rights reserved.</span>
  </div>);
}
